// Generic helper function to determine if a component should be rendered
export const shouldRenderComponent = (component: any, visibilityMap: { [key: string]: boolean } = {}) => {
	// Use visibility map to determine if component should be visible
	// If no entry exists in the visibilityMap, assume true (visible by default)
	return visibilityMap[component?.fieldName] !== false;
};
